function countTicketTypesDirective($rootScope) {
    'ngInject';

    return {
        restrict: 'A',
        scope: false,
        link(scope, element, attrs) {


            let countTicketTypes;
            $rootScope.connection_started.then(() => countTicketTypes());


            scope.$on('basket:updated', (event, basket) => countTicketTypes());


            return countTicketTypes = function (items) {

                items = scope.bb.basket.timeItems();

                const counts = [];
                for (const item of Array.from(items)) {
                    if (item.tickets) {
                        if (counts[item.tickets.name]) {
                            counts[item.tickets.name] += item.tickets.qty;
                        } else {
                            counts[item.tickets.name] = item.tickets.qty;
                        }
                        item.number = counts[item.tickets.name];
                    }
                }
                return scope.counts = counts;
            };
        }
    };
}

// returns the number of tickets selected, grouped by name
angular
    .module('BB')
    .directive('bbCountTicketTypes', countTicketTypesDirective);


// WEBPACK FOOTER //
// ../node_modules/bookingbug-angular/src/core/count-ticket-types/count_ticket_types.directive.js